var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___NkNUMF",
  "h_": "KeyboardModeIntroModal.module__description___NkNUMF",
  "Xq": "KeyboardModeIntroModal.module__tips___NkNUMF",
  "uN": "KeyboardModeIntroModal.module__tip___NkNUMF",
  "HP": "KeyboardModeIntroModal.module__keys___NkNUMF",
  "eS": "KeyboardModeIntroModal.module__kbd___NkNUMF",
  "me": "KeyboardModeIntroModal.module__separator___NkNUMF",
  "xY": "KeyboardModeIntroModal.module__tipText___NkNUMF",
};

module.exports = exports;
